import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/demo',
  //   component:resolve => require(['@/view/demo'],resolve),
  //   meta: { title: '首页' }
  // },
  {
    name: "home",
    path: "/",
    component: (resolve) => require(["@/view/index"], resolve),
    meta: { title: "首页" },
  },
  {
    name: "competitionList",
    path: "/competitionList",
    component: (resolve) => require(["@/view/competition/list"], resolve),
    meta: { title: "赛事列表" },
  },
  {
    name: "competitionDetail",
    path: "/competitionDetail",
    component: (resolve) => require(["@/view/competition/detail"], resolve),
    meta: { title: "赛事详情" },
  },
  {
    name: "login",
    path: "/login",
    component: (resolve) => require(["@/view/login"], resolve),
    meta: { title: "登录", layout: "blank" },
  },
  {
    name: "register",
    path: "/register",
    component: (resolve) => require(["@/view/register"], resolve),
    meta: { title: "注册", layout: "blank" },
  },
  {
    name: "signUp",
    path: "/signUp",
    component: (resolve) => require(["@/view/competition/signUp"], resolve),
    meta: { title: "比赛报名" },
  },
  {
    name: "grade",
    path: "/grade",
    component: (resolve) => require(["@/view/competition/grade"], resolve),
    meta: { title: "分数查看" },
  },
  {
    name: "workUpload",
    path: "/workUpload",
    component: (resolve) => require(["@/view/competition/workUpload"], resolve),
    meta: { title: "作品上传" },
  },

  {
    name: "examination",
    path: "/examination",
    component: (resolve) => require(["@/view/examination"], resolve),
    meta: { title: "等考" },
  },
  {
    name: "studying",
    path: "/studying",
    component: (resolve) => require(["@/view/studying"], resolve),
    meta: { title: "研学" },
  },
  {
    name: "cooperation",
    path: "/cooperation",
    component: (resolve) => require(["@/view/cooperation"], resolve),
    meta: { title: "合作案例" },
  },
  {
    name: "course",
    path: "/course",
    component: (resolve) => require(["@/view/course"], resolve),
    meta: { title: "课程" },
  },
  {
    name: "courseDetail",
    path: "/courseDetail",
    component: (resolve) => require(["@/view/course/detail"], resolve),
    meta: { title: "课程详情" },
  },
  {
    name: "page-not-found",
    path: "/*",
    meta: { title: "404", layout: "blank" },
    component: (resolve) => require(["@/view/pageNotFound"], resolve),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    //x代表横坐标，y代表纵坐标
    return { x: 0, y: 0 };
  },
  mode: "history", // hash有#
});

// 前置路由守卫
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

// 后置路由守卫  to，from
router.afterEach((to) => {
  document.title = to.meta.title || "";
});

export default router;
